import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { hideHelp, showHelpContent, Action, startHelpPanelDragging } from "../actions";
import { getHelpPanelState, getLocale, getTemplateText, HelpPanelContentType, State } from "../reducers";

import HelpPanel from '../components/HelpPanelView';
import { getTranslation } from "../services/translation-store";

interface StateProps {
    readonly visible: boolean,
    readonly text: string,
    readonly width: number,
    readonly backlink: string,
}

interface DispatchProps {
    readonly onHideHelp: () => void,
    readonly onBacklinkClickedFactory: (backlink: string) => () => void,
    readonly onStartDraggingSeparator: () => void,
}

interface Props extends StateProps {
    readonly onHideHelp: () => void,
    readonly onBacklinkClicked: () => void,
    readonly onStartDraggingSeparator: () => void,
}


const mapStateToProps = (state: State): StateProps => {
    const locale = getLocale(state);
    const {backlink, content, contentType, visible} = getHelpPanelState(state);

    let text;
    switch (contentType) {
        default:
            text = getTranslation(locale, content);
            break;
        case HelpPanelContentType.TemplateState:
            text = getTemplateText(state, content);
            break;
    }

    return {
        visible,
        text,
        width: getHelpPanelState(state).width,
        backlink,
    }
};

const mapDispatchToProps = (dispatch: ThunkDispatch<State, any, Action>): DispatchProps => (
    {
        onHideHelp: () => {
            dispatch(hideHelp());
        },
        onBacklinkClickedFactory: (backlink: string) => () => {
            dispatch(showHelpContent(HelpPanelContentType.General, backlink));
        },
        onStartDraggingSeparator: () => {
            dispatch(startHelpPanelDragging());
        }
    }
);

const mergeProps = (stateProps: StateProps, dispatchProps: DispatchProps): Props => (
    {
        ...stateProps,
        onHideHelp: dispatchProps.onHideHelp,
        onBacklinkClicked: dispatchProps.onBacklinkClickedFactory(stateProps.backlink),
        onStartDraggingSeparator: dispatchProps.onStartDraggingSeparator,
    }
);


export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps,
)(HelpPanel);



// WEBPACK FOOTER //
// ./src/containers/HelpPanel.ts